import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { CognitoUtilService } from "./cognito-util.service";
import * as AWS from "aws-sdk";
import * as S3 from "aws-sdk/clients/s3";
import { Observable }     from 'rxjs/Observable';
import { UserLoginService } from "./user-login.service";
import { S3Object } from '../shared/S3Object';
import { S3Folder } from '../shared/S3Folder';
import { File } from '../shared/File';
import { Folder } from '../shared/folder';
import 'rxjs/Rx'
//import { Contents } from '../shared/contents';


export interface CognitoCallback {
    cognitoCallback(message: string, result: any): void;
}
export interface CognitoCallback1 {
  cognitoCallback1(message: string, result: any): void;
}
export interface viewBreadCrumbFolderCallBack {
  viewBreadCrumbFolderCallBack(message: string, result: any): void;
}
export interface CreateAlbumCallback {
  CreateAlbumCallback(message: string, result: any): void;
}
export interface DeleteAlbumCallback {
  DeleteAlbumCallback(message: string, result: any): void;
}
export interface addFileCallback {
  addFileCallback(message: string, result: any): void;
}
export interface deletePhotosCallback {
  deletePhotosCallback(message: string, result: any): void;
}
export interface downloadFileCallback {
  downloadFileCallback(message: string, result: any): void;
}
export interface uploadCallBack {
  uploadCallBack(message: string, result: any): void;
}
export interface getObjectCallback {
  getObjectCallback(message: string, result: any): void;
}


@Injectable()
export class S3Service {

  constructor(public cognitoUtill: CognitoUtilService, public userService: UserLoginService) { }
  
  private getS3(): any {
    AWS.config.update({
        region: environment.bucketRegion,
    });
    console.log("S3Service: reading from s3 with creds - " + AWS.config.credentials.accessKeyId + ' / ' + AWS.config.credentials.secretAccessKey + ' / ' + AWS.config.credentials.sessionToken);
    
    let clientParams:any = {
        region: environment.bucketRegion,
        apiVersion: '2006-03-01',
        params: {Bucket: environment.rekognitionBucket}
    };
    if (environment.s3_endpoint) {
        clientParams.endpoint = environment.s3_endpoint;
    }
    var s3 = new S3(clientParams);

    return s3
  }

  public addPhoto(albumName,file,callback: addFileCallback) {
    console.log('addPhoto() file: ',file);
    
    var fileName = file.name;
    let albumPhotosKey = albumName ;
    if (albumName) {
      albumPhotosKey = albumPhotosKey ;
    }
  
    var photoKey = albumPhotosKey + fileName;
    this.getS3().upload({
      Key: photoKey,
      Body: file,
      ACL: 'public-read',
      Metadata: {
        Description: 'Tarkempaa tietoa kuvasta',
        /* '<MetadataKey>': ... */
      }
    }, function(err, data) {
      if (err) {
        callback.addFileCallback(err.message, data);;
      }
      //alert('Tiedoston siirto onnistui');
      callback.addFileCallback(null, data);;
    });
  }


  // Not working yet!!!
  public downloadFile(file,callback: downloadFileCallback) {
    let albumPhotosKey =  file.replace(/ /g, ' '); 
    console.log('albumPhotosKey :',albumPhotosKey);
    var fileKey = albumPhotosKey  ;
    console.log('fileKey:',fileKey);
    let params = {
      Bucket: environment.rekognitionBucket, 
      Key: fileKey
     };
     this.getS3().getSignedUrl('getObject', params, (err, url) => {
       if (err) {
         callback.downloadFileCallback(err.message, null);;
        console.log(err, err.stack); // an error occurred
       }
       else{
        console.log(url);           // successful response
      //  var blob = new Blob([data.body], { type: 'application/octet-stream' });
        //var url= window.URL.createObjectURL(blob);
        window.open(url);

        callback.downloadFileCallback(null, url);;
       } 
       /*
       data = {
        AcceptRanges: "bytes", 
        ContentLength: 3191, 
        ContentType: "image/jpeg", 
        ETag: "\"6805f2cfc46c0f04559748bb039d69ae\"", 
        LastModified: <Date Representation>, 
        Metadata: {
        }, 
        TagCount: 2, 
        VersionId: "null"
       }
       */
     });


  }
  public getObject(file,bucket,callback: getObjectCallback) {
    console.log('getObject() file:', file);
  let params = {
    Bucket: bucket, 
    Key: file
   };
   this.getS3().getObject(params, (err, data) => {
     if (err){
      console.log(err, err.stack); // an error occurred
      callback.getObjectCallback(err, null);;
     }
      
     else   {
      console.log(data);           // successful response
      callback.getObjectCallback(null, data);

     } 
     /*
     data = {
      AcceptRanges: "bytes", 
      ContentLength: 3191, 
      ContentType: "image/jpeg", 
      ETag: "\"6805f2cfc46c0f04559748bb039d69ae\"", 
      LastModified: <Date Representation>, 
      Metadata: {
      }, 
      TagCount: 2, 
      VersionId: "null"
     }
     */
   });

  }


  public deletePhotos( photoKeys,callback: deletePhotosCallback) {
    console.log('deletePhotos()',photoKeys);
    let params = {
      Bucket: environment.rekognitionBucket, 
      Delete: {
       Objects: [], 
       Quiet: false
      }
     };
     for (let i = 0; i < photoKeys.length; i++) {
      params.Delete.Objects.push({Key: photoKeys[i]}) ;
     }
     console.log('deletePhotos() params: ',params);
    
    this.getS3().deleteObjects(params, (err, data) => {
      if (err) {
        console.log('Tiedoston poisto epäonnistui ', err.message);
        callback.deletePhotosCallback(err.message,data );
        ;
      }
        console.log('Tiedoston poisto onnistui.');
        callback.deletePhotosCallback(null, data);
    });
  }




  public deletePhoto(albumName, photoKey) {
    this.getS3().deleteObject({Key: photoKey}, function (err, data) {
      if (err) {
        console.log('There was an error deleting your photo: ', err.message);
        return;
      }
        console.log('Successfully deleted photo.');
    });
  }

  public createAlbum(albumName,callback: CreateAlbumCallback) {
    console.log('createAlbum() albumName: ',albumName);
    albumName = albumName.trim();
    if (!albumName) {
      return alert('Album names must contain at least one non-space character.');
    }
   /* if (albumName.indexOf('/') !== -1) {
      return alert('Album names cannot contain slashes.');
    } */
    var albumKey = albumName + '/';
    this.getS3().headObject({Key: albumKey}, (err, data) => {
      if (!err) {
        return alert('Album already exists.');
      }
      console.log ('err: ', err);
      if (err.code !== 'NotFound') {
        return alert('There was an error creating your album: ' + err.message);
      }
      this.getS3().putObject({Key: albumKey}, function(err, data) {
        if (err) {
          return alert('There was an error creating your album: ' + err.message);
        }
        //alert('Successfully created album.');
        callback.CreateAlbumCallback(null, data);;
      });
    });
  }

  public deleteAlbum(albumName,callback: DeleteAlbumCallback) {
    var albumKey = albumName + '/';
    this.getS3().listObjects({Prefix: albumKey}, (err, data) => {
      if (err) {
        return alert('There was an error deleting your album: ' + err.message);
      }
      var objects = data.Contents.map(function(object) {
        return {Key: object.Key};
      });
      this.getS3().deleteObjects({
        Delete: {Objects: objects, Quiet: true}
      }, function(err, data) {
        if (err) {
          return alert('There was an error deleting your album: '+ err.message);
        }
        //alert('Successfully deleted album.');
        callback.DeleteAlbumCallback(null, data);
      });
    });
  }



  public listAlbums(callback: CognitoCallback1) {
    let folder: Folder =  {
      name : environment.rekognitionBucket,
      folders:[],
      files:[]
    };
    

    this.getS3().listObjects({Delimiter: '/'}, (err, data) => {
      if (err) {
        callback.cognitoCallback1('There was an error listing your albums: ' + err.message,null);
      } else {
        let koko = data.Contents;
        let folders: string[]  = data.CommonPrefixes.map((commonPrefix) => {
          let album: string = decodeURIComponent(commonPrefix.Prefix.replace('/', ''))
          return album;
        });
          folder.folders = folders;
        
        
        let files = data.Contents.map((contents,i) => {       
          var urlParams = {Bucket: environment.rekognitionBucket, Key: contents.Key};
          this.getS3().getSignedUrl('getObject', urlParams, (err, url) => {
            if (err) {
              return console.error(err);  // don't fail here
            }
            let key:string  = contents.Key;
            let type: string = 'file';
            if  (key.endsWith('/')){
              type = 'folder';
            }  
            else if ( key.endsWith('.jpg') || key.endsWith('.JPG') || key.endsWith('.img') )    {
              console.log('it is picture');
              type = 'picture';
            }
            let file: File = {
              name: contents.Key,
              edited: contents.LastModified,
              url: url,
              type: type
            }
            console.log('file: ',file);
            folder.files.push(file);
            
            if (i == (koko.length -1)) {  // last iteration
              console.log('last iteration');
              callback.cognitoCallback1(null, folder);;
            }
        });        
      });
    
  }
});
  }


  public viewAlbum(albumName, bucket ,callback: CognitoCallback){
    console.log('viewAlbum() albumName: ',albumName);
   // let albumPhotosKey = encodeURIComponent(albumName) + '/';
   let albumPhotosKey = albumName ;
    console.log('viewAlbum() albumPhotosKey: ',albumPhotosKey);
    
    let s3ObjectTable:S3Object[] =[];
    let s3FolderTable:S3Folder[] =[];
    let s3Table = {s3ObjectTable, s3FolderTable};
    let folder: Folder =  {
      name :albumName,
      folders:[],
      files:[]
    };
        //let params = {Bucket: environment.rekognitionBucket,Delimiter: '/', Prefix:'Hakemisto1/'}; // haetaan hakemiston ja sen tiedostot
    //let params = {Bucket: environment.rekognitionBucket, Prefix:'Hakemisto1/'}; // haetaan hakemisto1 ja kaikki sen alla olevat hakemistot ja tiedostot
    //let params = {Bucket: environment.rekognitionBucket,Delimiter: '/'}; // haetaan juuresta tiedostot tai haetaan ne joissa ei ole ko. merkkijonoa.
    //let params = {Bucket: environment.rekognitionBucket,EncodingType: "url",}; // Haetaan kaikki
    let params = {Bucket: bucket, Prefix:albumPhotosKey, Delimiter: '/'};
    this.getS3().listObjectsV2(params,(err, data) => {
      if (err) {
        callback.cognitoCallback(err,null);
      }
      let bucketContents = data.Contents;
      let koko = data.Contents;
      console.log('data: ', data);
      

       data.CommonPrefixes.forEach((commonPrefix) => {
                
       if (commonPrefix.Prefix === (albumName+"/") ) {
          console.log('sama: ', commonPrefix.Prefix);
          
        }
        else {
          let album: string = decodeURIComponent(commonPrefix.Prefix)
          folder.folders.push(album);
        }
      });
        //folder.folders = folders;
      if (data.KeyCount === 0){
        callback.cognitoCallback("Kyseistä hakemistoa ei löydy", null);
      }
      else {
        let files = data.Contents.map((contents,i) => {       
          var urlParams = {Bucket:bucket, Key: contents.Key};
          this.getS3().getSignedUrl('getObject', urlParams, (err, url) => {
            if (err) {
              return console.error(err);  // don't fail here
            }
            let file: File = {
              name: '',
              edited: contents.LastModified,
              url: url,
              type: 'file'
            }
            console.log('contents.Key: ',contents.Key);
            let fileName = contents.Key.split("/");
            let key:string  = contents.Key;
            if (fileName.length == 1){
              file.name = fileName[0]
            }
            console.log('fileName.length: ',fileName.length);

            if  (contents.Key.endsWith('/')){
              console.log('it is folder');
              file.name = fileName[fileName.length-2] ;
              file.type = 'folder'
            }
            else {
              if ( key.endsWith('.jpg') || key.endsWith('.JPG') || key.endsWith('.img'))    {
                console.log('it is picture');
                file.type = 'picture';
                file.name = fileName[fileName.length-1];
              }
              else {
                file.name = fileName[fileName.length-1];
              }

              console.log('file: ',file);
              folder.files.push(file);
            }
            if (i == (koko.length -1)) {  // last iteration
              console.log('last iteration');
              callback.cognitoCallback(null, folder);;
            }
          });        
        });
      }
    });
  }
 
public upload (content, bucket, name, callback: uploadCallBack){
  var params = {Bucket: bucket, Key: name, Body: content};
  this.getS3().upload(params, (err, data) => {
    if (err) {
      console.log('Tiedoston siirto epäonnistui ', err.message);
      callback.uploadCallBack(err.message,data );
      ;
    }
      console.log('Tiedoston siirto onnistui.');
      callback.uploadCallBack(null, data);
  });
    
 };




 public viewBreadCrumbFolder(albumName,callback: viewBreadCrumbFolderCallBack){
    console.log('viewBreadCrumbFolder() albumName: ',albumName);
   // let albumPhotosKey = encodeURIComponent(albumName) + '/';
   let albumPhotosKey = albumName ;
    console.log('viewBreadCrumbFolder() albumPhotosKey: ',albumPhotosKey);
    let s3ObjectTable:S3Object[] =[];
    let s3FolderTable:S3Folder[] =[];
    let s3Table = {s3ObjectTable, s3FolderTable};
    let folder: Folder =  {
      name :albumName,
      folders:[],
      files:[]
    };
    


    //let params = {Bucket: environment.rekognitionBucket,Delimiter: '/', Prefix:'Hakemisto1/'}; // haetaan hakemiston ja sen tiedostot
    //let params = {Bucket: environment.rekognitionBucket, Prefix:'Hakemisto1/'}; // haetaan hakemisto1 ja kaikki sen alla olevat hakemistot ja tiedostot
    //let params = {Bucket: environment.rekognitionBucket,Delimiter: '/'}; // haetaan juuresta tiedostot tai haetaan ne joissa ei ole ko. merkkijonoa.
    //let params = {Bucket: environment.rekognitionBucket,EncodingType: "url",}; // Haetaan kaikki
    let params = {Bucket: environment.rekognitionBucket, Prefix:albumPhotosKey, Delimiter: '/'};
    this.getS3().listObjectsV2(params,(err, data) => {
      if (err) {
        callback.viewBreadCrumbFolderCallBack(err,null);
      }
      let bucketContents = data.Contents;
      let koko = data.Contents;
      console.log('data: ', data);
      
      data.CommonPrefixes.map((commonPrefix) => {
        let album: string = decodeURIComponent(commonPrefix.Prefix)
        folder.folders.push(album);
        
      });

      let files = data.Contents.map((contents,i) => {       
        var urlParams = {Bucket: environment.rekognitionBucket, Key: contents.Key};
        this.getS3().getSignedUrl('getObject', urlParams, (err, url) => {
          if (err) {
            return console.error(err);  // don't fail here
          }
          let file: File = {
            name: '',
            edited: contents.LastModified,
            url: url,
            type: 'file'
          }
          console.log('contents.Key: ',contents.Key);
          let fileName = contents.Key.split("/");
          let key:string  = contents.Key;
          if (fileName.length == 1){
            file.name = fileName[0]
          }
          console.log('fileName.length: ',fileName.length);

          if  (contents.Key.endsWith('/')){
            console.log('it is folder');
            file.name = fileName[fileName.length-2] ;
            file.type = 'folder'
          }
          else if ( key.endsWith('.jpg') || key.endsWith('.JPG') || key.endsWith('.img')  )    {
              console.log('it is picture');
              file.type = 'picture';
              file.name = fileName[fileName.length-1]
          }

          console.log('file: ',file);
          folder.files.push(file);
          
          if (i == (koko.length -1)) {  // last iteration
            console.log('last iteration');
            callback.viewBreadCrumbFolderCallBack(null, folder);;
          }
      });        
    });
    });
  }
 

  
}



// WEBPACK FOOTER //
// ./src/app/service/s3.service.ts